import styled, { css } from 'styled-components/macro';

export const StyledTrigger = styled.div`
  ${({ theme }) => css`
    position: relative;
    padding: 9px ${theme.spacings.s};
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: ${theme.spacings.xs};
    background: ${theme.semantic.field.bg};
    border: 1px solid ${theme.semantic.border.control};
    border-radius: ${theme.radiuses.xs};
    outline: 4px solid transparent;
    transition-property: outline, border-color, color, background-color;
    transition-duration: ${theme.tokens.animation.duration.base};

    &[data-loading='true'] {
      cursor: wait;
    }

    &:not(&[data-loading='true']) {
      cursor: pointer;

      &:not(:focus-within):not(:has(input:disabled)):hover {
        border-color: ${theme.semantic.border.controlHover};
      }

      &:has(input:focus) {
        border-color: ${theme.semantic.border.focus};
      }

      &:has(input:disabled) {
        background-color: ${theme.semantic.field.bgDisabled};
        border-color: ${theme.semantic.border.control};
        cursor: not-allowed;
      }
    }
  `}
`;

export const ChipsWrapper = styled.div<{ $multi: boolean }>`
  ${({ theme, $multi }) => css`
    padding: 0;
    position: relative;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacings.xs};
    width: 100%;
    min-height: 20px;
    height: fit-content;
    overflow: hidden;

    ${!$multi &&
    css`
      &:focus-within *:not(input) {
        display: none;
      }
    `};
  `}
`;

export const Placeholder = styled.span<{ $show: boolean }>`
  ${({ theme, $show }) => css`
    display: ${$show ? 'inline-flex' : 'none'};
    align-items: center;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    color: ${theme.semantic.text.placeholder};
    pointer-events: none;
    z-index: 1;
  `}
`;

export const RequiredMark = styled.span`
  ${({ theme }) => css`
    margin-left: 2px;
    /* Роли под звёздочку обязательного поля в дизайн-системе нет:
       text/error — это сообщение об ошибке под полем. */
    color: ${theme.colors.red[500]};
  `}
`;

export const SearchInput = styled.input<{ $show: boolean }>`
  ${({ theme, $show }) => css`
    padding: 0;
    flex: 1;
    border: none;
    outline: none;
    background-color: transparent;
    color: ${theme.semantic.text.default};
    cursor: inherit;

    ${!$show &&
    css`
      &:not(:focus) {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0 0 0 0);
        white-space: nowrap;
        border: 0;
      }
    `};

    &::placeholder {
      color: ${theme.semantic.text.placeholder};
    }
  `}
`;
